"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var http_1 = require("@angular/common/http");
var validation_service_deserialization_helper_1 = require("./validation-service-deserialization-helper");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/from");
require("rxjs/add/operator/mergeMap");
var ValidationHttpService = /** @class */ (function () {
    function ValidationHttpService(httpClientWrapper, applicationPropertiesService, kbService, languageService) {
        this.httpClientWrapper = httpClientWrapper;
        this.applicationPropertiesService = applicationPropertiesService;
        this.kbService = kbService;
        this.languageService = languageService;
        this.URL_VALIDATE_ENTITY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/validate/", ""], ["", "/validate/", ""])), "serviceUri", "categorySystemName");
        this.URL_VALIDATE_FIELD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/validate/", "/", ""], ["", "/validate/", "/", ""])), "serviceUri", "categorySystemName", "fieldSystemName");
        this.URL_CALCULATE_VALIDATE_ENTITY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/calculateandvalidate/", ""], ["", "/calculateandvalidate/", ""])), "serviceUri", "categorySystemName");
        this.URL_CALCULATE_VALIDATE_ENTITY_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/", "/calculateandvalidate/", ""], ["", "/", "/calculateandvalidate/", ""])), "serviceUri", "customPrefix", "categorySystemName");
        this.URL_CALCULATE_VALIDATE_FIELD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/calculateandvalidate/", "/", ""], ["", "/calculateandvalidate/", "/", ""])), "serviceUri", "categorySystemName", "fieldSystemName");
        this.URL_CALCULATE_VALIDATE_FIELD_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/", "/calculateandvalidate/", "/", ""], ["", "/", "/calculateandvalidate/", "/", ""])), "serviceUri", "customPrefix", "categorySystemName", "fieldSystemName");
        this.URL_CATEGORY_REQUIRED_META_FIELD_IDS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", "/requiredfields/", ""], ["", "/requiredfields/", ""])), "serviceUri", "categorySystemName");
        this.URL_CATEGORY_REQUIRED_META_FIELD_IDS_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", "/", "/requiredfields/", ""], ["", "/", "/requiredfields/", ""])), "serviceUri", "customPrefix", "categorySystemName");
        this.validationCalculationServiceUriKey = "validation-calculation-service-url";
        this.validationCalculationServiceUriKey$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.validationCalculationServiceUriKey));
        this.languages$ = this.languageService.getAvailableLanguages();
    }
    ValidationHttpService.prototype.validateEntity = function (categorySystemName, serializedEntity, workflowStateId) {
        return this.calculateAndValidateEntity(categorySystemName, serializedEntity, workflowStateId)
            .map(function (validationAndCalculations) {
            return validationAndCalculations.getValidations();
        });
    };
    ValidationHttpService.prototype.validateField = function (categorySystemName, fieldSystemName, serializedEntity, workflowStateId) {
        return this.calculateAndValidateField(categorySystemName, fieldSystemName, serializedEntity, workflowStateId)
            .map(function (validationAndCalculations) {
            return validationAndCalculations.getValidations();
        });
    };
    ValidationHttpService.prototype.calculateAndValidateEntity = function (categorySystemName, serializedEntity, workflowStateId, customPrefix, actionId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categorySystemName);
        var url$ = this.validationCalculationServiceUriKey$
            .map(function (uri) {
            return !customPrefix ? _this.URL_CALCULATE_VALIDATE_ENTITY.replaceTemplate({
                "serviceUri": uri,
                "categorySystemName": categorySystemName
            }) : _this.URL_CALCULATE_VALIDATE_ENTITY_WITH_PREFIX.replaceTemplate({
                "serviceUri": uri,
                "customPrefix": customPrefix,
                "categorySystemName": categorySystemName
            });
        });
        return this.getCalculations(url$, categorySystemName, serializedEntity, workflowStateId, actionId);
    };
    ValidationHttpService.prototype.calculateAndValidateField = function (categorySystemName, fieldSystemName, serializedEntity, workflowStateId, customPrefix, actionId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categorySystemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(fieldSystemName);
        var url$ = this.validationCalculationServiceUriKey$
            .map(function (uri) {
            return !customPrefix ? _this.URL_CALCULATE_VALIDATE_FIELD.replaceTemplate({
                "serviceUri": uri,
                "categorySystemName": categorySystemName,
                "fieldSystemName": fieldSystemName
            })
                : _this.URL_CALCULATE_VALIDATE_FIELD_WITH_PREFIX.replaceTemplate({
                    "serviceUri": uri,
                    "customPrefix": customPrefix,
                    "categorySystemName": categorySystemName,
                    "fieldSystemName": fieldSystemName
                });
        });
        return this.getCalculations(url$, categorySystemName, serializedEntity, workflowStateId, actionId);
    };
    ValidationHttpService.prototype.getCategoryRequiredMetaFieldIds = function (categorySystemName, workflowStateId, customPrefix) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categorySystemName);
        return this.validationCalculationServiceUriKey$
            .map(function (uri) {
            return !customPrefix ? _this.URL_CATEGORY_REQUIRED_META_FIELD_IDS.replaceTemplate({
                "serviceUri": uri,
                "categorySystemName": categorySystemName
            })
                : _this.URL_CATEGORY_REQUIRED_META_FIELD_IDS_WITH_PREFIX.replaceTemplate({
                    "serviceUri": uri,
                    "customPrefix": customPrefix,
                    "categorySystemName": categorySystemName
                });
        })
            .mergeMap(function (url) {
            if (workflowStateId) {
                var params = new http_1.HttpParams();
                params = params.set("workflowStateId", workflowStateId.toString());
                return _this.httpClientWrapper.get(url, { params: params });
            }
            return _this.httpClientWrapper.get(url);
        })
            .map(function (data) {
            var metaFieldIds = [];
            data.forEach(function (dataItem) {
                metaFieldIds.push(_this.kbService.extractMetaFieldId(dataItem));
            });
            return metaFieldIds;
        });
    };
    ValidationHttpService.prototype.getValidationsCalculations = function (url$, categorySystemName, serializedEntity, validateOrCalculate, workflowStateId, actionId) {
        var _this = this;
        var metaFields$ = this.kbService.getMetaFields(categorySystemName);
        var response = Observable_1.Observable.combineLatest(url$, this.languages$)
            .mergeMap(function (data) {
            var params = _this.initParams(workflowStateId, actionId);
            // console.error(data[0] + " " + params.toString());
            if (workflowStateId || actionId) {
                return _this.httpClientWrapper.post(data[0], serializedEntity, { params: params });
            }
            return _this.httpClientWrapper.post(data[0], serializedEntity);
        });
        return Observable_1.Observable.combineLatest(response, metaFields$, this.languages$)
            .map(function (data) {
            return validateOrCalculate(data[0], data[1], data[2]);
        });
    };
    ValidationHttpService.prototype.initParams = function (workflowStateId, actionId) {
        var params = new http_1.HttpParams();
        if (workflowStateId)
            params = params.set("workflowStateId", workflowStateId.toString());
        if (actionId)
            params = params.set("actionId", actionId.toString());
        return params;
    };
    ValidationHttpService.prototype.getValidations = function (url$, categorySystemName, serializedEntity, workflowStateId) {
        return this.getValidationsCalculations(url$, categorySystemName, serializedEntity, validation_service_deserialization_helper_1.deserializeValidations, workflowStateId);
    };
    ValidationHttpService.prototype.getCalculations = function (url$, categorySystemName, serializedEntity, workflowStateId, actionId) {
        return this.getValidationsCalculations(url$, categorySystemName, serializedEntity, validation_service_deserialization_helper_1.deserializeValidationsCalculationsData, workflowStateId, actionId);
    };
    ValidationHttpService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService])
    ], ValidationHttpService);
    return ValidationHttpService;
}());
exports.ValidationHttpService = ValidationHttpService;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=validation-http.service.js.map